module.exports = __webpack_public_path__ + "static/media/press_content_01.bc64b34b.png";